import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';

const AnnouncementBanner = () => {
  return (
    <section className="bg-black border-b border-white/10">
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="py-6 flex items-center justify-center gap-4"
        >
          <div className="flex items-center gap-6">
            <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg"
                alt="AWS Logo"
                className="w-10 h-10 brightness-0 invert"
              />
            </div>
            <div className="text-center">
              <p className="text-base md:text-lg text-white">
                <span className="font-semibold">Solutions21 is now an AWS Partner!</span>
                {" "}
                <span className="text-gray-400">
                  We're thrilled to announce our official partnership with Amazon Web Services (AWS).
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AnnouncementBanner;